import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import type { TranslationKey } from '../models';
import { sitecoreTranslation } from './i18n';

interface SitecoreTranslation {
    [key: number]: number | string;
    [key: string]: number | string;
}

const translateKey = (key: TranslationKey, t: TFunction, interpolationOptions?: SitecoreTranslation): string => {
    if (typeof interpolationOptions === 'undefined') {
        return t(key);
    }

    return t(key, sitecoreTranslation(interpolationOptions));
};

export function useTranslationByKey(): (key: TranslationKey, interpolationOptions?: SitecoreTranslation) => string {
    const [t] = useTranslation();
    const returnFunc = (key: TranslationKey, interpolationOptions?: SitecoreTranslation): string =>
        translateKey(key, t, interpolationOptions);

    return returnFunc;
}
